import React from 'react';
import CheckIcon from 'ui/Icons/tabler/check.component.svg';
import CrossIcon from 'ui/Icons/tabler/x.component.svg';
import { EInvoiceUploadStatus } from '../types';

interface IStatusCellProps {
  status?: EInvoiceUploadStatus;
}

export const StatusCell: React.FC<IStatusCellProps> = ({ status }) => {
  if (status === EInvoiceUploadStatus.APPROVED) {
    return (
      <span
        title="Approved"
        className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-teal-100 text-white"
      >
        <CheckIcon width={12} height={12} className="stroke-current" />
      </span>
    );
  }
  if (status === EInvoiceUploadStatus.REJECTED) {
    return (
      <span
        title="Rejected"
        className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-red-95 text-white"
      >
        <CrossIcon width={12} height={12} className="stroke-current" />
      </span>
    );
  }
  return <span className="text-gray-60">—</span>;
};
